module.exports = "https://ec-cstatic.akulaku.net/mall/growth-publish/_next/static/images/Picture-bc213609645fa7c1c377a29f994c8f5a.png";